module.exports = __webpack_public_path__ + "img/data-item1-1.0fc22f7.png";